var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_10863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6643 3.74798L20.1108 20.3365C20.4099 21.1214 20.0278 21.7737 19.3466 21.9948C18.61 22.2103 17.8512 22.133 17.5245 21.2375L15.73 16.3787H8.19243L6.34263 21.3204C6.07126 22.133 5.33466 22.2435 4.62576 22.0003C3.94455 21.7571 3.5901 21.2154 3.88917 20.4249L10.369 3.74798C10.7234 2.82486 11.2939 2.52637 12.0028 2.52637C12.7117 2.52637 13.3098 2.82486 13.6643 3.74798ZM10.7788 9.39724L9.01209 14.0957H14.9159L13.1769 9.39724C12.6895 8.03744 12.3074 6.95402 11.9806 5.8706C11.6262 7.06457 11.2994 8.01533 10.7843 9.39724H10.7788Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_10863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4211,
    height: 19.5789,
    fill: "white",
    transform: "translate(3.78955 2.52637)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIcon);
export default __webpack_public_path__ + "static/media/aIcon.7ac4d2ce6d838450305cf09d5aed862d.svg";
export { ForwardRef as ReactComponent };